import { render, staticRenderFns } from "./Medicos.vue?vue&type=template&id=50672127&scoped=true&"
import script from "./Medicos.vue?vue&type=script&lang=js&"
export * from "./Medicos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/dropfile.css?vue&type=style&index=1&id=50672127&prod&scoped=true&lang=css&"
import style2 from "./Medicos.vue?vue&type=style&index=2&id=50672127&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50672127",
  null
  
)

export default component.exports